/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Collaborators_Nrolescreated2Inputs */

const en_settings_collaborators_nrolescreated2 = /** @type {(inputs: Settings_Collaborators_Nrolescreated2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} created`)
};

/**
* | output |
* | --- |
* | "{count} created" |
*
* @param {Settings_Collaborators_Nrolescreated2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_nrolescreated2 = /** @type {((inputs: Settings_Collaborators_Nrolescreated2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Nrolescreated2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_nrolescreated2(inputs)
});
export { settings_collaborators_nrolescreated2 as "settings_collaborators_nRolesCreated" }